import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_APPLICATION } from '@/modules/apps/router';
import { applicationService } from '@/services/applications';
import { useRoute } from 'vue-router';
import { useMixins } from './mixins';

export default function () {
    const route = useRoute();
    const router = useAppRouter();

    const { model, v$, currencyOptions } = useMixins();
    const { executeAction, excuteAndNotify, confirmAndRemove, confirmAndExecute } = useCrudActions();

    const fetch = executeAction({
        request: () => applicationService.app.get(route.params.id),
        onSuccess: ({ data }) => {
            data.removeTime = data.removeTime ? new Date(data.removeTime) : null;
            data.createTime = data.createTime ? new Date(data.createTime).toString() : '';

            Object.assign(model, data);
        },
        onError: () => router.push({ name: ROUTE_NAME_APPLICATION.INDEX })
    });

    const actions = {
        update: excuteAndNotify({
            request: () =>
                applicationService.app.update(
                    model.id,
                    model.name,
                    model.currency,
                    model.creditInit,
                    model.friendLimit,
                    model.popupRate,
                    model.bindSuggestTime,
                    model.remainVipMinutes,
                    model.vipTermMinutes,
                    model.creditWelcomeLimit,
                    model.thumbnailFile
                ),
            validator: v$,
            onSuccess: fetch
        }),
        remove: confirmAndRemove({
            request: () => applicationService.app.remove(model.id),
            onSuccess: fetch
        }),
        unremove: confirmAndExecute({
            confirmMessage: 'Are you sure you want to undelete this item?',
            request: () => applicationService.app.undelete(model.id),
            onSuccess: fetch
        })
    };

    return { model, currencyOptions, v$, fetch, actions };
}
